<template>
    <div class="ObjectLikeButtons">
        <ObjectLikeButtonsWrapper :status="status" :id="id">
            <template #dislike="{active, onClick}">
                <button @click="onClick" :class="['ObjectLikeButtons__dislike', {'ObjectLikeButtons__dislike--active': active}]">
                    <DislikeIcon/>
                    <span class="text">Не нравится</span>
                </button>
            </template>
            <template #like="{active, onClick}">
                <button @click="onClick" :class="['ObjectLikeButtons__like', {'ObjectLikeButtons__like--active': active}]">
                    <LikeIcon/>
                    <span class="text">Нравится</span>
                </button>
            </template>
        </ObjectLikeButtonsWrapper>
    </div>
</template>

<script>
import LikeIcon from '@/assets/image/icons/like.svg?inline';
import DislikeIcon from '@/assets/image/icons/dislike.svg?inline';
import ObjectLikeButtonsWrapper from "@/components/Object/ObjectLikeButtonsWrapper";

export default {
    name: "ObjectLikeButtons",
    components: {
        LikeIcon,
        DislikeIcon,
        ObjectLikeButtonsWrapper,
    },
    props: {
        id: [Number, String],
        status: Number,
    },
}
</script>

<style lang="scss">
.ObjectLikeButtons {

  .ObjectLikeButtonsWrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 16px;
    white-space: nowrap;
  }

  button {
    padding: 0 9px;
  }

  &__like {
    background: none;
    color: $secondary;
    border: solid 2px $secondary;

    &--active {
      color: $white;
      background-color: $secondary;

      @include svgFill($white);
    }
  }

  &__dislike {
    color: $primary;
    background: none;

    &--active {
      @include svgFill($primary);
    }
  }
}
</style>